module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1200.534ee4f4.svg";